export default __webpack_public_path__ + "static/media/Trio-Tenor-You-raise-me-up-Master-1-2.b43f83ea.wav";